import React, { useState } from 'react';
import './Header.css';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <nav className="hector-nav">
      <div className="nav-container">
        <div className="nav-logo">
          <h2>Hector Díaz</h2>
          <span className="nav-subtitle">Master Artist & Visionary</span>
        </div>
        <div className={`nav-menu ${isMenuOpen ? 'nav-menu-active' : ''}`}>
          <a href="#home" className="hector-nav-link">Home</a>
          <a href="#biography" className="hector-nav-link">Biography</a>
          <a href="#videos" className="hector-nav-link">Videos</a>
          <a href="#timeline" className="hector-nav-link">Timeline</a>
          <a href="#gallery" className="hector-nav-link">Gallery</a>
          <a href="#articles" className="hector-nav-link">Articles</a>
          <a href="#legacy" className="hector-nav-link">Legacy</a>
        </div>
        <div className="nav-toggle" onClick={() => setIsMenuOpen(!isMenuOpen)}>
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </div>
      </div>
    </nav>
  );
};

export default Header;